import { isString } from '@showroomjs/core';
import { useSearchParams } from '@showroomjs/bundles/routing';
export const useQueryParams = () => {
    const [params, setParams] = useSearchParams();
    return [
        params,
        function setParamsValue(value, { replace = true, merge } = {}) {
            if (merge) {
                const nextQuery = searchParamsToObject(params, Object.keys(value));
                Object.entries(value).forEach(([key, value]) => {
                    if (isString(value)) {
                        nextQuery[key] = value;
                    }
                });
                setParams(nextQuery, { replace });
            }
            else {
                setParams(value, { replace });
            }
        },
    ];
};
export const searchParamsToObject = (search, excludes = []) => {
    const result = {};
    search.forEach((value, key) => {
        if (!excludes.includes(key)) {
            result[key] = value;
        }
    });
    return result;
};
//# sourceMappingURL=use-query-params.js.map